export const Paper = () => ({
  styleOverrides: {
    root: {
      backgroundImage: 'none'
    }
  }
});